import { Fragment, useMemo } from 'react';
import { useServices } from 'stores/user/userHooks';
import { User } from 'stores/user/userTypes';

interface GoogleMapProps {
  user: User | undefined;
}

export default function GoogleMap({ user }: GoogleMapProps) {
  const [services] = useServices();
  const service = useMemo(() => {
    if (services && user) {
      return services.find(({ zips }) => {
        const dep = user.patient.zip.slice(0, 2);

        return zips.includes(dep);
      });
    }
    return null;
  }, [user, services]);

  if (!service) {
    return null;
  }

  return (
    <Fragment>
      <h1 className='mb-4 text-xl font-bold text-center text-secondary'>
        Nous trouver
      </h1>
      <div className='text-center'>{`Conseil d’accès : ${service.tips_1}`}</div>
      <div className='text-center'>{service.tips_2}</div>
      <div className='w-full p-4'>
        <div
          className='w-full h-[375px]'
          id='map'
        >
          <iframe
            title='map'
            className='w-full h-full'
            src={`https://www.google.com/maps/embed/v1/search?q=${service.address}&key=${process.env.REACT_APP_GOOGLE_MAP_API_KEY}`}
          />
        </div>
      </div>
    </Fragment>
  );
}
